module.exports = __webpack_public_path__ + "img/wang.7456b59d.png";